export const logo_src = "/images/logo.png";
